
import {defineComponent} from "vue";
import DataMixins from "@/mixins/DataMixins";

export default defineComponent({
  name: 'ModTitleComponent',
  mixins: [DataMixins],
  props: {
    author: {
      type: String,
      required: true
    },
    version: {
      type: String,
      required: true
    },
    game: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
})
